// 'DBX demo' org
import {useBasicApi, useFullApi} from "./core/api/Api";
import {ReactComponent as TryMe} from "./upsolver-images/try-me.svg";
import React, {PropsWithChildren} from "react";
import {useQuery} from "react-query";
import {useLoginStateProvider} from "./LoginStateProvider";

export const links = Object.freeze({
  integ: "https://streams.upsolver.com",
  local: "http://localhost:3001",
  prod: "https://db.upsolver.com",
  e2e: "https://e2e-db.upsolver.com",
});

function dbxDeploymentLinks(deployment: string) {
  const link = links[deployment as keyof typeof links];
  if (link == null) {
    throw Error(`Bad deployment name: ${deployment}`);
  }
  return link;
}

const envType = process.env.REACT_APP_ENV_TYPE;

const style = { background: "transparent", display: "inline-flex", alignItems: "flex-end", width:85, height: 85 };
function SwapperButton() {
  const api = useFullApi();
  const link = dbxDeploymentLinks(envType);
  if (!link) {
    return null;
  }

  const linkWithImpersonation = new URL(link);
  if (api.impersonateOrganizationId) {
    linkWithImpersonation.searchParams.set("impersonate", api.impersonateOrganizationId);
  }
  return (
    <a href={linkWithImpersonation.toString()} style={style}>
      <TryMe />
    </a>
  );
}

function AclChecker() {
  const api = useBasicApi();
  const { data } = useQuery(["dbx-acl-check"], () => api.get<boolean>("users/has-dbx"));
  return data === true ? <SwapperButton /> : null;
}

function OrganizationDbxStatusChecker({children}: PropsWithChildren<unknown>) {
  const { status } = useLoginStateProvider();
  const exposeToUsers = status?.selectedOrganization?.flags?.dbxSupportState?.exposeToUsers;
  if (exposeToUsers == null || exposeToUsers === false) {
    return null;
  }

  return <>{children}</>;
}

function VersionSwapper() {
  return <OrganizationDbxStatusChecker> <AclChecker /></OrganizationDbxStatusChecker>;
}

export default VersionSwapper;
